import React, { Component } from "react";
import Counter from "./counter";

class Counters extends Component {
  render() {
    const {
      onReset,
      onNew,
      onClear,
      onIncrement,
      counters,
      onRemove,
      onDelete,
    } = this.props;
    return (
      <div>
        <div className="control row">
          <button className="btn btn-info btn-sm shadow mr-3" onClick={onNew}>
            New Product
          </button>
          <button className="btn btn-info btn-sm shadow mr-3" onClick={onReset}>
            Reset All
          </button>
          <button className="btn btn-info btn-sm shadow mr-3" onClick={onClear}>
            Clear
          </button>
        </div>

        {counters.map((counter) => (
          <Counter
            key={counter.id}
            counter={counter}
            onRemove={onRemove}
            onIncrement={onIncrement}
            onDelete={onDelete}
          ></Counter>
        ))}
      </div>
    );
  }
}

export default Counters;
